import { AGGREGATABLE_KEY_TYPES, NUMERIC_KEY_TYPES } from '../constants/aggregations';
import { tableCoverageGroup } from './tableFieldGroups';

export function isNumericField(field) {
  if (!field) return false;
  const keyType = String(field.key_type || '').toUpperCase();
  if (keyType && !NUMERIC_KEY_TYPES.includes(keyType)) return false;
  if (field.is_numeric === true) return true;
  return NUMERIC_KEY_TYPES.includes(keyType);
}

export function isAggregatableField(field) {
  if (!field) return false;
  const keyType = String(field.key_type || '').toUpperCase();
  return AGGREGATABLE_KEY_TYPES.includes(keyType);
}

export function prepareMeasureFieldOptions(formFields = []) {
  const union = new Set();
  (formFields || []).forEach((field) => {
    (field.form_ids || []).forEach((id) => union.add(String(id)));
  });

  return (formFields || [])
    .filter(isAggregatableField)
    .map((field) => {
      const formIds = (field.form_ids || []).map(String);
      const partial = union.size > 1 && formIds.length > 0 && formIds.length < union.size;
      const names = (field.forms || []).map((form) => form.label).filter(Boolean);
      return {
        id: field.id,
        label: field.label,
        key_type: field.key_type,
        form_ids: formIds,
        forms: field.forms || [],
        partial,
        group: union.size < 2 ? '' : tableCoverageGroup(partial, names),
      };
    })
    .sort((left, right) => {
      if (left.group === right.group) return 0;
      if (!left.partial) return -1;
      if (!right.partial) return 1;
      return left.group.localeCompare(right.group);
    });
}

export function buildMeasureSummaryLabel({
  aggregation = 'count',
  measureFieldLabel = '',
  categoryLabel = '',
}) {
  const measure = buildYAxisMeasureLabel(aggregation, measureFieldLabel);
  if (!categoryLabel) return measure;
  return `${measure} by ${categoryLabel}`;
}

export function joinValueList(values = []) {
  const items = (values || []).filter(Boolean);
  if (items.length <= 1) return items[0] || '';
  if (items.length === 2) return `${items[0]} and ${items[1]}`;
  return `${items.slice(0, -1).join(', ')}, and ${items[items.length - 1]}`;
}

export function buildReportSentence({
  chartType = 'bar',
  aggregation = 'count',
  measureFieldLabel = '',
  categoryLabel = '',
  includedValues = [],
}) {
  const measure = buildYAxisMeasureLabel(aggregation, measureFieldLabel);
  let sentence = measure;
  if (chartType === 'line') {
    sentence = `${measure} over time`;
  } else if (categoryLabel) {
    sentence = `${measure} by ${categoryLabel}`;
  }
  const only = joinValueList(includedValues);
  if (only) sentence = `${sentence}, only ${only}`;
  return sentence;
}

export function buildYAxisMeasureLabel(aggregation = 'count', measureFieldLabel = '') {
  if (aggregation === 'count' || !measureFieldLabel) {
    return 'Record count';
  }
  const prefix = {
    sum: 'Sum of',
    avg: 'Average',
    min: 'Min',
    max: 'Max',
  }[aggregation];
  return prefix ? `${prefix} ${measureFieldLabel}` : measureFieldLabel;
}

export default prepareMeasureFieldOptions;
